import React, { FC, useEffect } from 'react';

import { adminActions, getWorkshiftDetails } from '@pharmaplan/common';

import LongShiftDistributionModal from '../../SelfService/PharmacistProfile/LongShiftDistributionModal';
import useFormatShiftDetails from '../../../hooks/AvailableWorkshift/useFormatShiftDetails';
import { useAppDispatch } from '../../../hooks/useAppDispatch';

interface IAdminLongTermShiftDetails {
  workshiftId: string;
}

const AdminLongTermShiftDetails: FC<IAdminLongTermShiftDetails> = ({
  workshiftId,
}) => {
  const dispatch = useAppDispatch();
  const { details } = useFormatShiftDetails();

  useEffect(() => {
    dispatch(getWorkshiftDetails({ id: workshiftId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LongShiftDistributionModal
      successAction={adminActions.getWorkshiftDetails}
      details={details}
    />
  );
};

export default AdminLongTermShiftDetails;
